import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "100vw",
    height: "100vh",
    maxHeight: "100vh",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    width: `100%`,
    overflowY: "auto",
  },

  link: {
    "&:not(:first-child)": {
      paddingLeft: 15,
    },
  },
  installAppBack: {
    position: "fixed",
    display: "flex",
    top: 0,
    left: 0,
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(0,0,0,0.5)",
    zIndex: 100000000000000,
  },
  installAppContainer: {
    width: 300,
    height: "auto",
    padding: 15,
    background: "white",
    borderRadius: 15,
  },
  installAppTitle: { fontSize: 16, fontWeight: "bold" },
  installAppAction: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
}));
